import { render, staticRenderFns } from "./EmptyTokens.vue?vue&type=template&id=a2f44a64&"
import script from "./EmptyTokens.vue?vue&type=script&lang=ts&"
export * from "./EmptyTokens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports